import Vue from "vue";
import PastimesDesktop from "@/build/tmp/pastimesdesktop.vue";

import vueCustomElement from 'vue-custom-element'
Vue.use(vueCustomElement);

Vue.customElement('prz-pastimesdesktop', PastimesDesktop);